<template>
  <div class="how-to">
    <h1 class="text-shadow-thin-white">{{ $t("dresden.howToPlay") }}</h1>
    <p>{{ $t("dresden.howP1") }}</p>
    <p>
      {{ $t("dresden.howP2") }}
      <span class="highlight text-shadow-extra-thin-white">
        {{ $t("dresden.howP2Highlight") }}
      </span>
    </p>
    <p>
      <span class="highlight text-shadow-extra-thin-white">
        {{ $t("dresden.howP3Highlight") }}
      </span>
      {{ $t("dresden.howP3") }}
    </p>
  </div>
</template>
<script>
export default {
  name: "DresdenHowTo",
};
</script>
